<template>
  <div>
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.$store.getters.isAdmin || this.$store.getters.isMod) {
      this.$router.push({ name: 'recipes' })
    } else {
      this.$router.push({ name: 'orders' })
    }
  },
}
</script>
